// Report Type
export const ONE_PAGER_REPORT_KEY = 'one_pager_report';
export const EXTENDED_REPORT_KEY = 'extended_report';

// PDF Configuration
export const LANDSCAPE_ORIENTATION = 'l';
export const MILLIMETERS_MEASUREMENT_UNIT = 'mm';
export const A4_SHEET_FORMAT = 'a4';
export const CANVAS_CONVERSION_SCALE = 2;
export const CANVAS_QUALITY_IMAGE = 0.6;

// Keys
export const YEAR_PROJECTION_DISBURSEMENT_KEY = 'annual_projection';
export const DONE_DISBURSEMENT_KEY = 'disbursed';
export const GREATHER_THAN_3MM_KEY = 'GREATER_THAN_3MM';
export const SUBPRODUCT_CONTENT_KEY = 'outputNM';
export const RISK_CONTENT_KEY = 'descriptionRiskProgram';

// Pagination Sections
export const LIMIT_ACCORDANCES_PER_PAGE = 5;
export const LIMIT_RISKS_PER_PAGE = 12;
export const LIMIT_PRODUCTS_PER_PAGE = 6;
export const MAX_SUBPRODUCTS_PER_COMPONENT = 6;
export const MAX_COLUMNS_IN_COMPONENT_BALANCES = 3;
export const LIMIT_DETAILS_FOR_COMPONENT_SINGLE_VIEW = 12;
export const LIMIT_WORDS_FOR_COMPONENT_SINGLE_VIEW = 170;
export const LIMIT_WORDS_FOR_RISKS_VIEW = 600;
export const LIMIT_DETAILS_FOR_COMPONENT_FULL_SCREEN = 36;

// Index
export const LOAN_TYPE_INDEX = 0;
export const IGR_TYPE_INDEX = 3;

// Delay
export const DELAY_GENETATION_PER_SECTION = 1200;

// Format
export const DEFAULT_DATE_FORMAT = 'DD/MMM/YYYY';
export const REGEX_REPLACE_POINT = /\./g;

// Acquisitions
export const MIN_PERCENT_FROM_VIEW_PROGRESS = 2;
export const MIN_PERCENT_FROM_VIEW_VALUE_PROGRESS = 8;

// Styles
export const MAX_LINES_FOR_APPLY_ELLIPSIS_OBJECTIVE = 17;
export const MAX_LINES_FOR_APPLY_ELLIPSIS_OBJECTIVE_TCDI = 20;
export const MAX_LINES_FOR_APPLY_ELLIPSIS_FOR_COMMENTS = 10;
export const OBJECTIVES_CSS_CLASS = '.objective-text';
export const OBJECTIVES_TCDI_CSS_CLASS = '.objective-text-tcdi';
export const COMMENTS_CSS_CLASS = '.comments-text';